// Race condition in the kaching cart fix 
(() => {
  if (window.__raceConditionDetectorInstalled) return;
  window.__raceConditionDetectorInstalled = true;

  const DISCOUNT_PARAMS = ['abralink', 'discount', 'promo', 'code'];
  const STORAGE_KEY = '__abra_discount_codes';
  const ATTEMPT_KEY = '__abra_discount_attempt_key';
  const DEBOUNCE_MS = 1200;

  let inProgress = false;
  let lastAttemptAt = 0;
  let cookiesPrimedFor = '';

  const safeGet = (storage, key) => {
    try { return storage.getItem(key); } catch (e) { return null; }
  };
  const safeSet = (storage, key, value) => {
    try { storage.setItem(key, value); } catch (e) {}
  };
  const safeJson = (text) => {
    try { return JSON.parse(text); } catch (e) { return null; }
  };
  const pickCode = (value) => {
    if (typeof value !== 'string') return null;
    const code = value.trim();
    return /^[A-Za-z0-9_-]{3,40}$/.test(code) ? code : null;
  };

  const isAbraActive = () => {
    const classes = Array.from(document.body?.classList || []);
    return classes.some((c) => /^abra--.+-(applied|activated)$/i.test(c));
  };

  const getCodesFromActivePromotion = () => {
    const raw = safeGet(localStorage, 'abra:active-promotion');
    const parsed = raw ? safeJson(raw) : null;
    const discountCodes = parsed?.promotion?.discountCodes;
    if (!Array.isArray(discountCodes)) return [];
    return discountCodes.map(pickCode).filter(Boolean);
  };

  const getDiscountCodes = () => {
    const params = new URLSearchParams(location.search);
    const fromUrl = DISCOUNT_PARAMS.reduce((acc, key) => acc || params.get(key), null);
    const urlCode = pickCode(fromUrl);

    const promoCodes = getCodesFromActivePromotion();
    const stored = safeJson(safeGet(sessionStorage, STORAGE_KEY)) || [];

    const merged = [];
    if (urlCode) merged.push(urlCode);
    promoCodes.forEach((c) => merged.push(c));
    stored.forEach((c) => merged.push(c));

    const unique = Array.from(new Set(merged));
    if (unique.length) safeSet(sessionStorage, STORAGE_KEY, JSON.stringify(unique));
    return unique;
  };

  const hasDiscount = (cart) =>
    !!(
      cart?.total_discount > 0 ||
      cart?.items?.some((i) => i?.discounts?.length > 0) ||
      (Array.isArray(cart?.discount_codes) && cart.discount_codes.some((c) => c?.applicable !== false)) ||
      (Array.isArray(cart?.allCodeDiscounts) && cart.allCodeDiscounts.length > 0)
    );

  const pushCode = async (code) => {
    await fetch(`/discount/${encodeURIComponent(code)}?_abraignore=1`, {
      method: 'GET',
      credentials: 'include',
      redirect: 'manual',
    }).catch(() => {});
  };

  const primeCookies = async (codes) => {
    if (cookiesPrimedFor === codes.join(',')) return;
    for (const code of codes) await pushCode(code);
    cookiesPrimedFor = codes.join(',');
  };

  const apply = async (codes, attemptKey) => {
    const now = Date.now();
    if (inProgress || now - lastAttemptAt < DEBOUNCE_MS) return;
    inProgress = true;
    lastAttemptAt = now;
    try {
      await primeCookies(codes);
      const cart = window.kachingCartApi?.getCartData?.();
      const needsRefresh = (cart?.items?.length || 0) > 0 && !hasDiscount(cart);
      if (needsRefresh) {
        try { await window.kachingCartApi?.refreshCart?.(); } catch (e) {}
      }
    } finally {
      inProgress = false;
      safeSet(sessionStorage, ATTEMPT_KEY, attemptKey);
    }
  };

  const maybeApply = (cartData) => {
    if (!isAbraActive()) return;
    const codes = getDiscountCodes();
    if (!codes.length) return;

    const cartToken = cartData?.token || window.kachingCartApi?.getCartData?.()?.token || 'no-token';
    const itemCount = cartData?.item_count ?? cartData?.items?.length ?? 0;
    const attemptKey = `${codes.join(',').toUpperCase()}|${cartToken}|${itemCount}`;
    if (safeGet(sessionStorage, ATTEMPT_KEY) === attemptKey) return;

    apply(codes, attemptKey);
  };

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = (typeof args[0] === 'string' ? args[0] : args[0]?.url) || '';
    return originalFetch.apply(this, args).then(async (res) => {
      if (url.includes('_abraignore')) return res;
      if (!url.includes('cart/add')) return res;
      try {
        const clone = res.clone();
        maybeApply(await clone.json());
      } catch (e) {}
      return res;
    });
  };

  if (isAbraActive()) {
    const codes = getDiscountCodes();
    if (codes.length) primeCookies(codes);
    maybeApply(window.kachingCartApi?.getCartData?.() || {});
  }

})();